import React from 'react';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../../styles/carousel.css';
import {Carousel} from 'react-responsive-carousel';


export default function Nasa() {

    return (
        <div>
            <div>
                <Carousel dynamicHeight showArrows={false} showStatus={false} className="presentation-mode" showThumbs={false} autoPlay
                          interval={5000} infiniteLoop >
                    <div>
                        <img alt="Hector at JPL Ops Lab 1" className="image" src="assets/nasa/1.png"/>
                    </div>
                    <div>
                        <img alt="Hector testing Magic Leap" className="image" src="assets/nasa/2.png"/>
                    </div>
                    <div>
                        <img alt="Hector at JPL Mission Ops" className="image" src="assets/nasa/3.png"/>
                    </div>
                    <div>
                        <img alt="Hector at JPL Clean Room" className="image" src="assets/nasa/4.png"/>
                    </div>
                    <div>
                        <img alt="Hector at JPL Ops Lab 2" className="image" src="assets/nasa/5.png"/>
                    </div>
                    <div>
                        <img alt="Hector at JPL Mars 2020 Rover" className="image" src="assets/nasa/6.png"/>
                    </div>
                    <div>
                        <img alt="Hector at JPL Mars Yard" className="image" src="assets/nasa/7.png"/>
                    </div>
                    <div>
                        <img alt="Hector at JPL Ops Lab VR Test" className="image" src="assets/nasa/8.png"/>
                    </div>
                    <div>
                        <img alt="Hector at JPL Opportunity Replica" className="image" src="assets/nasa/9.png"/>
                    </div>
                </Carousel>
            </div>
            <div className="content">
                <h1>My Work at the Jet Propulsion Lab!</h1>
                <p>One of the most rewarding jobs I've ever had was at the Jet Propulsion Laboratory in Pasadena. I was in charge of a team that focused in Mission Planning, Sequencing and Commanding of all sorts of spacecrafts, from CubeSats to Flag Missions like Mars 2020 Rover and Europa Clipper.</p>
                <p>I also worked as deputy manager for the Engineering Analysis Systems group for Mars 2020. We developed visualization applications for telemtry coming from the Rover. </p>
            </div>
        </div>
    );

}


// WEBPACK FOOTER //
// ./src/components/sections/Nasa.jsx